module.exports = __webpack_public_path__ + "img/figure-11.46883aea.png";